import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { patchPrimeNgDrawerMask } from "./shared/utils/primeng-drawer-mask-fix";

@Component({
  selector: "twx-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  providers: [ConfirmationService, DialogService],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = "twx-web-client";

  ngOnInit(): void {
    patchPrimeNgDrawerMask();
  }
}
